import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListConsultantComponent } from './components/list-consultant/list-consultant.component';
import { IntercontratComponent } from './components/intercontrat/intercontrat.component';
import { SuggestionJobRequestComponent } from './components/suggestion-job-request/suggestion-job-request.component';
import { SuggestionJobOfferComponent } from './components/suggestion-job-offer/suggestion-job-offer.component';
import { ListconsultantclientComponent } from './components/listconsultantclient/listconsultantclient.component';
import { AddConsultantComponent } from './add-consultant/add-consultant.component';
import { UpdateConsultantComponent } from './update-consultant/update-consultant.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'liste',
    pathMatch: 'full',
  },
  {
    path: 'liste',
    component: ListConsultantComponent,
    // canActivate: [esnAbonneeGuard.canActivate]
  },
  {
    path: 'consultants-client/:id',
    component: ListconsultantclientComponent,
  },
  {
    path: 'intercontrat',
    component: IntercontratComponent,
    // canActivate: [esnAbonneeGuard.canActivate]
  },
  {
    path: 'suggestion-jobOffer',
    component: SuggestionJobOfferComponent,
  },
  {
    path: 'suggestion-jobRequest',
    component: SuggestionJobRequestComponent,
  },
  {
    path: 'ajout-consultant',
    component: AddConsultantComponent,
  },
  {
    path: 'modification-consultant',
    component: UpdateConsultantComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConsultantRoutingModule {}
